<div class="logs-signpost-custom-groups">
    <ng-content></ng-content>

    <div
        *ngIf="trafficLogsSignpostStore.logsGroupsSignpostData$ | async as logsGroupsSignpostData"
        class="logs-signpost-custom-groups__grids-section"
    >
        <ng-container *ngFor="let group of logsGroupsSignpostData; trackBy: trackbyIndex">
            <avi-dynamic-data-grid
                *ngIf="group.children.length"
                class="logs-signpost-custom-groups__data-grid"
                [config]="groupsGridConfig"
                [rows]="group.children"
                [rowsTotal]="group.children.length"
                [gridTitle]="group.name"
            ></avi-dynamic-data-grid>
        </ng-container>
    </div>
</div>

<div
    class="logs-signpost-custom-groups__loader clr-wrapper"
    *ngIf="trafficLogsSignpostStore.isLoading$ | async"
>
    <clr-spinner [clrMedium]="true"></clr-spinner>
</div>

<ng-template
    #nameFieldTemplateRef
    let-row
    let-index="index"
>
    <span
        class="logs-signpost-custom-groups__name-column"
        *ngIf="row.value.isValid"
        logFilter
        [property]="row.value.param"
        [value]="row.value.value"
        [operator]="row.value?.contains ? FilterOperatorType.CONTAINS : FilterOperatorType.EQUAL_TO"
        (onFilterAdd)="trafficLogsSignpostStore.closeSignpost()"
    >
        {{ row.value.display || row.value.value }}
    </span>
    <span
        *ngIf="!row.value.isValid"
        logFilterableEmptyField
        [property]="row.value.param"
        (onFilterAdd)="trafficLogsSignpostStore.closeSignpost()"
        class="logs-signpost-custom-groups__empty-field"
    ></span>
</ng-template>

<ng-template
    #progressBarFieldTemplateRef
    let-row
    let-index="index"
>
    <avi-progress-bar
        [percentage]="row.percentage"
        [hidePercentage]="true"
    ></avi-progress-bar>
</ng-template>
